import { isValidJson } from 'components/form/utilities'
import React, { useCallback, useRef, useState } from 'react'
import { LinkedPaths } from './Paths'

export default function ConditionalLogic({ value, required, onChange, linkedPaths, onSave, onError }) {
  const textAreaRef = useRef()
  const [isValid, setIsValid] = useState(true)
  const [error, setError] = useState(null)

  const storeIfValid = useCallback(() => {
    try {
      const data = JSON.parse(value)
      // Check for specific schema constraints
      if (data.if) {
        throw new Error('"if" wrapper should not be included.')
      }
      setIsValid(true)
      setError(null)
      onSave(data)
    } catch (err) {
      const errorMessage = err instanceof SyntaxError ? 'Invalid JSON format' : err.message

      setIsValid(false)
      setError(errorMessage)
      onError?.(errorMessage)
    }
  }, [value, onSave, onError])

  const handleKeyDown = useCallback(
    (e) => {
      if (e.ctrlKey || e.metaKey) {
        switch (e.code) {
          case 'KeyS':
            e.preventDefault()
            storeIfValid()
            break
        }
      }
      if (e.target === textAreaRef.current) e.stopPropagation()
    },
    [storeIfValid]
  )

  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      <div className="dome-d-flex dome-flex-column">
        <div className="dome-d-flex dome-justify-between">
          <span className="dome-p2 dome-color-darkest-grey">conditional logic:*</span>
          {required && (
            <div className="dome-d-flex dome-align-center dome-gap3">
              <i className="fa-light fa-circle-exclamation dome-color-red-alert"></i>
              <span className="dome-p3 dome-color-red-alert">required</span>
            </div>
          )}
        </div>
        <textarea
          value={value}
          ref={textAreaRef}
          onChange={onChange}
          onBlur={storeIfValid}
          onKeyDown={handleKeyDown}
          placeholder="input conditional logic to determine when value is visible."
          style={{
            borderColor: isValid ? '#898989' : '#d7272d',
            borderRadius: 6,
            padding: '10px 18px 0px 18px',
            minHeight: 110,
          }}
        ></textarea>
        {error && <span className="dome-p3 dome-color-red-alert">{error}</span>}
      </div>
      <LinkedPaths linkedPaths={linkedPaths} />
    </div>
  )
}
